export default [
  'arabic',
  'hindi',
  'indonesia',
  'mundo',
  'persian',
  'pidgin',
  'portuguese',
  'thai',
  'turkce',
];
